/// <reference path="Configuracion.js" />
/// <reference path="Configuracion.js" />
/// <reference path="CargasArchivos.js" />
/// <reference path="eventosPantallaInicial.js" />
/// <reference path="ListaEmpresas.js" />
/// <reference path="FichaEmpresa.js" />


var CatalogoWebUI = new ViewModelListaEmpresas();
var FichaUI = new ViewModelFichaEmpresa();

var oControlador;

//para el menu PIM deben estar fuera del objeto para llamarlo desde NAV.exe
function VolverAtras()
{
    GetObjControlador().GoBack();
}
function PuedoVolverAtras() {
    return GetObjControlador().CanGoBack();
}
function IrAdelante() {
    GetObjControlador().GoForward();
}
function PuedoIrAdelante() {
    return GetObjControlador().CanGoForward();
}
// fin para menu PIM



function GetObjControlador() {
    if (oControlador == undefined) {
        oControlador = new ObjControlador();
    }
    return oControlador;
}

function ObjControlador() {
    var that = this;
    this.aHistorial = [];
    this.aHistorialDelante = [];
    this.urlSVR = "";
    this.urlNovedades = "";

    this.marcajeNuevoCatalogoWeb = function (categoria, valor)
    {
        addeventoanalitics(GetObjConfiguracion().feria, categoria, valor, 0);
    }
    
    this.saveAnalyticsOtros = function (categoria, valor)
    {
        that.marcajeNuevoCatalogoWeb(categoria, valor);
    }

    this.saveAnalyticsFiltros = function (opcionElegidaIndice)
    {
        var marcajeRealizado = false;

        //Opciones de busqueda generales por texto y letra.
        //tipoBusqueda puede ser TODO, EMPIEZAPOR o CONTIENE. 
        var tipoBusqueda = sacaParametro('t', location.hash);
        var txtBusqueda = sacaParametro2('b', location.hash);

        if (txtBusqueda && txtBusqueda.length > 0)
        {
            var descBusqueda;
            if (tipoBusqueda === "CONTIENE") descBusqueda = "Búsqueda Texto";
            if (tipoBusqueda === "EMPIEZAPOR") descBusqueda = "Búsqueda Letra";
            that.marcajeNuevoCatalogoWeb(descBusqueda, txtBusqueda);
            marcajeRealizado = true;
        }

        //Busqueda cruzada.
        if (GetObjConfiguracion().paisId && GetObjConfiguracion().paisId.length > 0)
        {
            var opcionElegidaPais = GetObjListaEmpresas().obtenerNombrePais();
            that.marcajeNuevoCatalogoWeb("Búsqueda País/Provincia", opcionElegidaPais);
            marcajeRealizado = true;
        }

        //Busqueda por indice.
        if (opcionElegidaIndice && opcionElegidaIndice.length > 0)
        {
            var nombreIndice = "";

            if (location.hash.search("#LSECTOR") >= 0) nombreIndice = "Búsqueda Sector"
            if (location.hash.search("#LACTIVIDAD") >= 0) nombreIndice = "Búsqueda Actividad";
            if (location.hash.search("#LPRODUCTOS") >= 0) nombreIndice = "Búsqueda Productos";
            if (location.hash.search("#LREPRESENTADAS") >= 0) nombreIndice = "Búsqueda Representadas";
            if (location.hash.search("#LMARCAS") >= 0) nombreIndice = "Búsqueda Marcas";
            if (location.hash.search("#GEN") >= 0) nombreIndice = "Búsqueda G: " + CatalogoWebUI.criterioElegido();
            if (location.hash.search("#LSTANDS") >= 0) nombreIndice = "Búsqueda Stands";

            that.marcajeNuevoCatalogoWeb(nombreIndice, opcionElegidaIndice);
            marcajeRealizado = true;
        }

        return marcajeRealizado;
    }

    this.getUrlSVR = function (data) {
        that.urlSVR = data;
    }
    GetCargaArchivos().cargarFicheroConfig(that.getUrlSVR, "../wsListaExpositores.svc/GetUrlSVR?");

    this.getUrlNovedades = function (data) {
        that.urlNovedades = data;
    }
    GetCargaArchivos().cargarFicheroConfig(that.getUrlNovedades, "../wsListaExpositores.svc/GetUrlNovedades?");

    // esta funcion es distinta en app de ferias y Catalogo Web por la forma de llegar a la ficha de empresa
    this.navegarAFichaEmpresa = function (empresa, stand)
    {
        that.navegarAPagina(GetObjConstantes()._FICHA, '#FICHA_EMPRESA?emp=' + empresa + '&s=' + stand);
    }

    this.navegarAPagina = function (Tipo,url) {
        if (GetObjConfiguracion().verPIM === 'S') {
            // al navegar se resetea el historial de GoForward
            that.aHistorialDelante= [];
            if (window.location.hash.length>0) that.aHistorial.push(window.location.hash);
            // that.imprimirPIM(Tipo, url);            
        }
        window.location.hash = url;
    }
    this.GoBack = function ()
    {
        if (that.aHistorial.length > 0)
        {
            var url = that.aHistorial.pop();
            that.aHistorialDelante.push(window.location.hash);
            if (url.length > 0) {
                window.location.hash = url;
            }
        }
    }
    this.GoForward = function ()
    {
        if (that.aHistorialDelante.length > 0) {
            var url = that.aHistorialDelante.pop();
            that.aHistorial.push(window.location.hash);
            if (url.length > 0) {
                window.location.hash = url;
            }
        }
    }
    this.CanGoBack = function ()
    {
        return (that.aHistorial.length > 0);
    }
    this.CanGoForward = function () {
        return (that.aHistorialDelante.length > 0);
    }

    this.imprimirPIM = function (Tipo, myurl) {
        var url="";
        var numPagina = sacaParametro('p', myurl);
        var idioma = sacaParametro('i', myurl);
        var tipoBusqueda = sacaParametro('t', myurl);
        var numEmpresas = sacaParametro('e', myurl);
        var txtBusqueda = sacaParametro2('b', myurl);
        var urlactual = window.location.href;
        var urlraiz = urlactual.substring(0, urlactual.indexOf("index.html") - 1);

        $("#impresionPIM").remove();

        switch (Tipo) {
            case GetObjConstantes()._LISTA:
                GetObjConfiguracion().busquedaActiva = 'T';
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                url = urlraiz + "/impresion_lista.html?feria=" + GetObjConfiguracion().feria;
                break;
            case GetObjConstantes()._SECTOR:
                var sector = sacaParametro('s', myurl);
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (sector != "") {
                    GetObjConfiguracion().filtroBusquedaActiva = sector;
                    GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    url = urlraiz + "/impresion_lista.html?feria=" + GetObjConfiguracion().feria;
                }
                break;
            case GetObjConstantes()._PAIS:
                var country = sacaParametro('c', myurl);
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (country != "") {
                    GetObjConfiguracion().filtroBusquedaActiva = country;
                    GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    url = urlraiz + "/impresion_lista.html?feria=" + GetObjConfiguracion().feria;
                }
                break;
            case GetObjConstantes()._ACTIVIDAD:
                var actividad = sacaParametro('a', myurl);
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (actividad != "") {
                    GetObjConfiguracion().filtroBusquedaActiva = actividad;
                    GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    url = urlraiz + "/impresion_lista.html?feria=" + GetObjConfiguracion().feria;
                }
                break;
            case GetObjConstantes()._PRODUCTO:
                var producto = sacaParametro('o', myurl);
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (producto != "") {
                    GetObjConfiguracion().filtroBusquedaActiva = producto;
                    GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    url = urlraiz + "/impresion_lista.html?feria=" + GetObjConfiguracion().feria;
                }
                break;
            case GetObjConstantes()._REPRESENTADA:
                var representadas = sacaParametro('r', myurl);
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (representadas != "") {
                    GetObjConfiguracion().filtroBusquedaActiva = representadas;
                    GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    url = urlraiz + "/impresion_lista.html?feria=" + GetObjConfiguracion().feria;
                }
                break;
            case GetObjConstantes()._MARCA:
                var marcas = sacaParametro('m', myurl);
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (marcas != "") {
                    GetObjConfiguracion().filtroBusquedaActiva = marcas;
                    GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    url = urlraiz + "/impresion_lista.html?feria=" + GetObjConfiguracion().feria;
                }
                break;
            case GetObjConstantes()._STAND:
                var stands = sacaParametro('st', myurl);
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                if (stands != "") {
                    GetObjConfiguracion().filtroBusquedaActiva = stands;
                    GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                    url = urlraiz + "/impresion_lista.html?feria=" + GetObjConfiguracion().feria;
                }
                break;
            case GetObjConstantes()._GENERICO:
                if (Tipo === GetObjConstantes()._GENERICO) {
                    var codGen = sacaParametro('g', myurl);
                    var subGen = sacaParametro('s', myurl);
                    GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'E');
                    if (subGen === "") {
                        GetObjConfiguracion().filtroBusquedaActiva = '';
                        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda, codGen);
                    }
                    else {
                        GetObjConfiguracion().filtroBusquedaActiva = subGen;
                        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
                        url = urlraiz + "/impresion_lista.html?feria=" + GetObjConfiguracion().feria;
                    }
                }
                break;
            case GetObjConstantes()._FAVORITOS:
                GetObjConfiguracion().numPagina = numPagina;
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'F');
                url = urlraiz + "/impresion_favoritos.html?feria=" + GetObjConfiguracion().feria;
                break;
            case GetObjConstantes()._FICHA:
                GetObjConfiguracion().nombreEmpresa = FichaUI.nombreEmpresa();
                var codEmpresa = sacaParametro('emp', myurl);
                url = urlraiz + "/impresion_ficha.html?feria=" + GetObjConfiguracion().feria + "&codEmpresa=" + codEmpresa;
                break;
            case GetObjConstantes()._MAPA_FERIA:
                GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'M');
                var stand = sacaParametro('s', myurl);
                url = urlraiz + "/impresion_plano.html?feria=" + GetObjConfiguracion().feria + "&s=" + stand;
                break;
            case GetObjConstantes()._MAPA_PABELLON:
                var pab = sacaParametro('p', myurl);
                var standp = sacaParametro('s', myurl);
                url = urlraiz + "/impresion_pabellon.html?feria=" + GetObjConfiguracion().feria + "&s=" + standp + "&p=" + pab;
                break;
            case GetObjConstantes()._NO_IMPRIMIR:
                //$("#impresionPIM").attr("URL1", "");
                break;
            default:
                break;

        }
        if (url != "") {
            $("#mainContainer").append("<PRINTBUTTON URL1='" + url + "' id='impresionPIM'>");
            GetImpresionLocalStorage().setParametros();
        };
        if (GetObjConstantes()._MODO_PRUEBA)
            window.open(url, "_blank", "toolbar=no, scrollbars=yes, resizable=no, top=0, left=0, width=900, height=1200");
    },
    this.imprimir = function (Tipo) {
        if (Tipo == GetObjConstantes()._FICHA)
            GetObjConfiguracion().nombreEmpresa = FichaUI.nombreEmpresa();
        GetImpresionLocalStorage().setParametros();
        switch (Tipo) {
            case GetObjConstantes()._LISTA:
                window.open("impresion_lista.html?feria=" + GetObjConfiguracion().feria, "_blank", "toolbar=no, scrollbars=yes, resizable=no, top=0, left=0, width=900, height=1200");
                var filtroActivo = GetObjConfiguracion().opcionFiltroTxt();
                GetObjControlador().saveAnalyticsOtros("Impresión Listado Empresas", filtroActivo);
                break;
            case GetObjConstantes()._FAVORITOS:
                window.open("impresion_favoritos.html?feria=" + GetObjConfiguracion().feria, "_blank", "toolbar=no, scrollbars=yes, resizable=no, top=0, left=0, width=900, height=1200");
                GetObjControlador().saveAnalyticsOtros("Impresión Favoritos", "");
                break;
            case GetObjConstantes()._FICHA:
                var codEmpresa = sacaParametro('emp', location.hash);
                window.open("impresion_ficha.html?feria=" + GetObjConfiguracion().feria + "&codEmpresa=" + codEmpresa, "_blank", "toolbar=no, scrollbars=yes, resizable=no, top=0, left=0, width=900, height=1200");
                GetObjControlador().saveAnalyticsOtros("Impresión Ficha Empresa", GetObjConfiguracion().nombreEmpresa);
                break;
            case GetObjConstantes()._MAPA_FERIA:
                var stand = sacaParametro('s', location.hash);
                window.open("impresion_plano.html?feria=" + GetObjConfiguracion().feria + "&s=" + stand, "_blank", "toolbar=no, scrollbars=yes, resizable=no, top=0, left=0, width=900, height=1200");
                if (stand === "")
                    GetObjControlador().saveAnalyticsOtros("Impresión Plano General", "Sin STAND");
                else
                    GetObjControlador().saveAnalyticsOtros("Impresión Plano General", "STAND: " + stand);
                break;
            case GetObjConstantes()._MAPA_PABELLON:
                //GetImpresionLocalStorage().setParametros();//DDC meto esto xq lo he visto en todos
                var pab = sacaParametro('p', location.hash);
                var stand = sacaParametro('s', location.hash);
                window.open("impresion_pabellon.html?feria=" + GetObjConfiguracion().feria + "&s=" + stand + "&p=" + pab, "_blank", "toolbar=no, scrollbars=yes, resizable=no, top=0, left=0, width=900, height=1200");
                if (stand === "")
                    GetObjControlador().saveAnalyticsOtros("Impresión Plano Pabellón", "Sin STAND");
                else
                    GetObjControlador().saveAnalyticsOtros("Impresión Plano Pabellón", "PAB: " + pab + " STAND: " + stand);
                break;
            case GetObjConstantes()._NO_IMPRIMIR:
                //$("#impresionPIM").attr("URL1", "");
                break;
            default:
                break;
        }
    }


    this.SplashCarga = function ()
    {
        if (GetObjConfiguracion().idio.toLowerCase() === 'es')
            $("#txtCargaEs").show();
        else
            $("#txtCargaEn").show();
    }

    this.CargaDatos = function () {

        if (GetObjConfiguracion().feria) {

            GetObjEventosPagInicial().loadCabecera();

            // cargamos ventanas html y archivos de configuracion inicial
            $.when(GetCargaArchivos().cargarFicheroHTMLDeferred("../waCatalogoWeb/ajax_expositores.html"),
                   GetCargaArchivos().cargarFicheroHTMLDeferred("../waCatalogoWeb/ajax_favoritos.html"),
                   GetCargaArchivos().cargarFicheroHTMLDeferred("../waCatalogoWeb/ajax_ListaEmpresas.html"),
                   GetCargaArchivos().cargarFicheroHTMLDeferred("../waCatalogoWeb/ajax_indice.html"),
                   GetCargaArchivos().CargarFicheroJSONDeferred("../wsListaExpositores.svc/GetConfiguracion?Feria=" + GetObjConfiguracion().feria),
                   GetCargaArchivos().CargarFicheroJSONDeferred("../wsListaExpositores.svc/GetIndiceMaestro?Feria=" + GetObjConfiguracion().feria + "&TipoIndice=G&numero=999&pagina=1")
                   ).done(

                   function (html_expositores, html_favoritos, html_listaEmpresas, html_Indice, json_configuracion, json_OpcionesGenericas) {
                       $('#contenedorExpositores').css("display", "block");
                       $("#contenedorExpositores").html(html_expositores[0]);
                       $("#contenedorFavoritos").html(html_favoritos[0]);
                       $("#ListaEmpresasTodasEmpresas").html(html_listaEmpresas[0]);
                       $("#ListaIndiceBusquedaSimple").html(html_Indice[0]);
                       GetObjConfiguracion().inicializaConfiguracion(eval(json_configuracion[0].d));
                       GetObjControlador().rellenarOpcionesMenuLateral(eval(json_OpcionesGenericas[0].d));
                       setTimeout(function () {
                           that.cargarConfiguracion();
                       }, 100);
                   }
                 );
        }
    }
    this.IniciarAplicacion = function ()
    {
        // GetObjConfiguracion().setFeria();
        // GetObjConfiguracion().setVersionPIM();
        GetObjConfiguracion().Inicializar();
        //[ALTIA]
        GetObjConfiguracion().cargaColoresCorporativos();
        GetObjConfiguracion().cargaLogoIfemaGetRecursos();

		//FIN [ALTIA]
        GetObjConfiguracion().LoadImagenesPorDefecto();

        if (GetObjConfiguracion().verPIM == 'S') {
            document.addEventListener('contextmenu', function(e) {
                e.preventDefault();
            },false);        
        }
        that.SplashCarga();
        

        //este es para que se mueva el relojito
        setTimeout(function () { that.CargaDatos() }, 0);


    }

    this.cargarConfiguracion = function () {
        ko.applyBindings(CatalogoWebUI);
        that.cambiarIdioma(GetObjConfiguracion().idio);
        InicializaEstadisticas();
        GetImpresionLocalStorage().nombreAlmacenImpresion = GetImpresionLocalStorage().nombreAlmacenImpresion + GetObjConfiguracion().feria;
        GetObjEventosPagInicial().inicializarCabeceraUI();
        GetObjListaEmpresas().eventosInterfazGrafica();
        GetObjNavegacion().InicializaWindowsLocation();
        GetFavoritos().AlmacenFavoritos = GetObjConfiguracion().feria;
        if (GetObjConfiguracion().verPIM === 'S') {
            GetFavoritos().LimpiarFavoritos();
            //alert('modo PIM');
            //$('#divScroll').show();
        }
        else {
            //alert('modo no PIM');
            //$('#divScroll').hide();
        }
        GetFavoritos().LoadArrayFavoritos();
        GetMapa().CargarRecinto();
        GetMapa().CargarPabellones();
        if (GetObjConfiguracion().verPIM === 'S')
            GetFavoritos().LimpiarFavoritos();

        GetObjListaEmpresas().setBusquedaActiva("#btnTodasEmpresas");
        GetObjListaEmpresas().activarNumeroEmpresasFiltrar(GetObjConfiguracion().numEmpresas);
        //$('#loading-indicator').css("left", $('#loading-indicator').parent().width() / 2 - 50 + 'px').css("top","80px");

        var p = $("#ListaEmpresasTodasEmpresas");
        var position = p.offset();
        var posx = position.left + p.width() / 2 + 'px';
        var posy = position.top + 100 + "px";
        $('#loading-indicator').css("left", posx).css("top", posy);

        //pruebas impresión
        var idiomaCache = '';
        var verPIMCache = '';

        if (getQueryVariable('idioma').toLowerCase() === 'es')
            idiomaCache = 'es';
        else {
            if (getQueryVariable('idioma').toLowerCase() === 'en')
                idiomaCache = 'en';
            else
                idiomaCache = 'es';
        }

        $("#divSplash").hide();

        //if (getQueryVariable('MODO').toUpperCase() === 'PIM') {
        if (GetObjConfiguracion().verPIM === 'S'){
            that.saveAnalyticsOtros("Tipo Acceso", "PIM");
            verPIMCache = 'S';
        }
        else {
            that.saveAnalyticsOtros("Tipo Acceso", "WEB");
            verPIMCache = 'N';
            

        }

        //alert('url'+window.location.hash);
        if (location.hash.length == 0)
            that.navegarAPagina(GetObjConstantes()._LISTA, '#LEMPRESAS&p=1&t=TODO'); //window.location.hash = '#LEMPRESAS&p=1&t=TODO';
        else
            that.navegarAPagina(GetObjConstantes()._LISTA, window.location.hash + '&access');//window.location.hash = window.location.hash + '&access';
    }

    this.visualizarEmpresas = function () {
        $("#ListaIndiceBusquedaSimple").hide();
        //$("#letraTodos").hide();
        $("#10").show();
        $("#filtroNumeroResultados").show();
        $("#ListaEmpresasTodasEmpresas").show();
    }

    this.cargarListaEmpresas = function (idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda) {
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
        GetObjListaEmpresas().cargarListaEmpresas();
    }

    this.cargarListaSectores = function (idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda) {
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
        //GetObjListaEmpresas().cargarListaSectores();
        GetObjListaEmpresas().cargarIndiceMaestro(GetObjConstantes()._SECTOR);
    }

    this.cargarListaPaises = function (idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda) {
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
        //GetObjListaEmpresas().cargarListaPaises();
        GetObjListaEmpresas().cargarIndiceMaestro(GetObjConstantes()._PAIS);
    }

    this.cargarListaGenericos = function (idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda, codGen) {
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda,codGen);
        //GetObjListaEmpresas().cargarListaGenericos(codGen);
        GetObjListaEmpresas().cargarIndiceMaestro(codGen);
    }

    this.cargarListaActividades = function (idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda) {
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
        //GetObjListaEmpresas().cargarListaActividades();
        GetObjListaEmpresas().cargarIndiceMaestro(GetObjConstantes()._ACTIVIDAD);
    }

    this.cargarListaProductos = function (idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda) {
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
        //GetObjListaEmpresas().cargarListaProductos();
        GetObjListaEmpresas().cargarIndiceMaestro(GetObjConstantes()._PRODUCTO);
    }

    this.cargarListaRepresentadas = function (idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda) {
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
        //GetObjListaEmpresas().cargarListaRepresentadas();
        GetObjListaEmpresas().cargarIndiceMaestro(GetObjConstantes()._REPRESENTADA);
    }

    this.cargarListaMarcas = function (idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda) {
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
        //GetObjListaEmpresas().cargarListaMarcas();
        GetObjListaEmpresas().cargarIndiceMaestro(GetObjConstantes()._MARCA);
    }

    this.cargarListaStands = function (idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda) {
        GetObjConfiguracion().actualizarFiltrosBusquedaListaEmpresas(idioma, numPagina, numEmpresas, tipoBusqueda, txtBusqueda);
        GetObjListaEmpresas().cargarIndiceMaestro(GetObjConstantes()._STAND);
    }

    this.cargarListaEmpresasFavoritas = function () {
        GetObjListaEmpresas().cargarListaEmpresasFavoritas();
    }
     
    this.cargarFichaEmpresa = function (codEmpresa, stand) {
       
        if ($('#contenedorFicha').children().length > 0) {
            $('#contenedorExpositores').hide();
            $('#contenedorFavoritos').hide();
            $('#contenedorMapas').hide();
            $('#contenedorFicha').show();
            GetObjFichaEmpresa().cargarFichaEmpresa(codEmpresa);
        }
        else {
            $.ajax({
                url: "../waCatalogoWeb/ajax_fichaEmpresa.html",
                success: function (data) {
                    $('#contenedorExpositores').hide();
                    $('#contenedorFavoritos').hide();
                    $('#contenedorMapas').hide();
                    $('#contenedorFicha').css("display", "block");
                    $("#contenedorFicha").html(data);
                
                    //DDC Esto no me gusta aquí, sería mejor en el onready del ajax
                    ko.applyBindings(FichaUI, document.getElementById("contenedorFicha"));
                    GetObjConfiguracion().inicializaFichaUI();
                    GetObjFichaEmpresa().cargarFichaEmpresa(codEmpresa, stand);
                
                }
            });
        }
    }


    this.cargarMapaFeria = function (sta) {
        GetCargaArchivos().cargarFicheroHTMLParametros(that.cargaHTMLMapaFeria, "../waCatalogoWeb/ajax_mapaferia.html", sta);
    }

    this.cargaHTMLMapaFeria = function (data, stand) {
        ko.cleanNode(document.getElementById("contenedorMapas"));
        $("#contenedorMapas").html(data);
        //Ajuste para el Modo PIM
        if (GetObjConfiguracion().verPIM == 'S') {
            var mapStyle = $("#MapaPabellones").attr("pim");
            $("#MapaPabellones").attr("pim", mapStyle + "PIM");
        }
        ko.applyBindings(CatalogoWebUI, document.getElementById("contenedorMapas"));
        $(".impresionPlano").click(function (event) {
            event.preventDefault();
            GetObjControlador().imprimir(GetObjConstantes()._MAPA_FERIA);
            //GetImpresionLocalStorage().setParametros();
            //var stand = sacaParametro('s', location.hash);
            //window.open("impresion_plano.html?feria=" + GetObjConfiguracion().feria + "&s=" + stand, "_blank", "toolbar=no, scrollbars=yes, resizable=no, top=0, left=0, width=900, height=1200");
        });
        GetMapa().IniciarMapaFeria(stand);
        CatalogoWebUI.setTextoFavoritos();
        GetObjEventosPagInicial().cursorArriba();
        if (GetObjConfiguracion().verPIM == 'S') {
            GetMapa().setEstilosMapasPIM();
        }

    }

    this.cargarMapaPabellon = function (pab, sta) {
        GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'M');
        GetCargaArchivos().cargarFicheroHTMLParametros(that.cargaHTMLMapaFeriaPabellon, "../waCatalogoWeb/ajax_mapapabellon.html", pab, sta);
    }

    this.cargaHTMLMapaFeriaPabellon = function (data, pabellon, stand) {
        ko.cleanNode(document.getElementById("contenedorMapas"));
        $("#contenedorMapas").html(data);
        //Ajuste para el Modo PIM
        if (GetObjConfiguracion().verPIM == 'S') {
            var mapStyle = $("#MapaStands").attr("pim");
            $("#MapaStands").attr("pim", mapStyle + "PIM");
        }
        ko.applyBindings(CatalogoWebUI, document.getElementById("contenedorMapas"));
        $(".impresionPabellon").click(function (event) {
            event.preventDefault();
            GetObjControlador().imprimir(GetObjConstantes()._MAPA_PABELLON);
            //GetImpresionLocalStorage().setParametros();
            //var pab = sacaParametro('p', location.hash);
            //var stand = sacaParametro('s', location.hash);
            //window.open("impresion_pabellon.html?feria=" + GetObjConfiguracion().feria + "&s=" + stand + "&p=" + pab, "_blank", "toolbar=no, scrollbars=yes, resizable=no, top=0, left=0, width=900, height=1200");
        });
        GetMapa().IniciarMapaPabellon(pabellon, stand);
        CatalogoWebUI.setTextoFavoritos();
        GetObjEventosPagInicial().cursorArriba();
        if (GetObjConfiguracion().verPIM == 'S') {
            GetMapa().setEstilosMapasPIM();
        }
    }

    this.pintaOpcion = function (ele) {
        if (ele != undefined) {
            CatalogoWebUI.setFlagOpcionElegida(true);
            CatalogoWebUI.setIdOpcionElegida(ko.dataFor(ele).id);
            CatalogoWebUI.setOpcionElegida();
        }
    }

    this.cambiarIdioma = function (idioma) {
        GetObjConfiguracion().cambiarIdioma(idioma);
        CatalogoWebUI.InicializarUI();
        FichaUI.setIdioma();
        var url = "../wsListaExpositores.svc/GetIndiceMaestro?Feria=" + GetObjConfiguracion().feria + "&TipoIndice=G&numero=999&pagina=1&idioma=" + GetObjConfiguracion().idio;
        GetCargaArchivos().CargarFicheroJSON(
            function (data) {
                that.rellenarOpcionesMenuLateral(data);
                CatalogoWebUI.setCriterioElegido(GetObjConfiguracion().busquedaActiva);
                if (GetObjConfiguracion().busquedaActiva == "P")
                    CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloIndicePais);
                else if (GetObjConfiguracion().busquedaActiva == "S")
                    CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloIndiceSector);
                else if (GetObjConfiguracion().busquedaActiva == "A")
                    CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloActividad);
                else if (GetObjConfiguracion().busquedaActiva == "M")
                    CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloIndiceMarcas);
                else if (GetObjConfiguracion().busquedaActiva == "ST")
                    CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloIndiceStands);
                else if (GetObjConfiguracion().busquedaActiva == "R")
                    CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloIndiceRepresentadas);
                else if (GetObjConfiguracion().busquedaActiva == "O")
                    CatalogoWebUI.tituloIndice(CatalogoWebUI.language().tituloProducto);
                else
                    CatalogoWebUI.tituloIndice(CatalogoWebUI.getTituloGenerico(that.busquedaActiva));
                setTimeout(function () { GetObjListaEmpresas().eventosMenuMovil(); }, 600);
                GetObjConfiguracion().actualizarDatosBusqueda();
            }, url);
    }


    this.rellenarOpcionesMenuLateral = function (data) {

        //opciones estáticas
        //CatalogoWebUI.menuLateral.push({ nombre: "Todas las empresas", nombrei: "All companies", tipo: "T" });
        CatalogoWebUI.limpiarMenuLateral();
        CatalogoWebUI.limpiarMenuMovil();

        if (GetObjConfiguracion().opActividad)
            CatalogoWebUI.menuLateral.push({ nombre: "Actividad", nombrei: "Activity", tipo: "A" });
        if (GetObjConfiguracion().opMarca)
            CatalogoWebUI.menuLateral.push({ nombre: "Marca", nombrei: "Trademark", tipo: "M" });
        if (GetObjConfiguracion().opStand)
            CatalogoWebUI.menuLateral.push({ nombre: "Stand", nombrei: "Stand", tipo: "ST" });
        if (GetObjConfiguracion().opProducto)
            CatalogoWebUI.menuLateral.push({ nombre: "Producto", nombrei: "Product", tipo: "O" });
        if (GetObjConfiguracion().opRepresentada)
            CatalogoWebUI.menuLateral.push({ nombre: "Representadas", nombrei: "Represented", tipo: "R" });
        if (GetObjConfiguracion().opSector)
            CatalogoWebUI.menuLateral.push({ nombre: "Sector", nombrei: "Sector", tipo: "S" });
        //---------------------- para movil 
        //CatalogoWebUI.menuMovil.push({ nombre: "Todas las empresas", nombrei: "All companies", tipo: "T" });
        CatalogoWebUI.menuMovil.push({ nombre: "Favoritos", nombrei: "Favourites", tipo: "F" });
        if (GetObjConfiguracion().opMapa)
            CatalogoWebUI.menuMovil.push({ nombre: "Plano interactivo", nombrei: "Interactive Floor Plan", tipo: "MAPA" });
        if (GetObjConfiguracion().opActividad)
            CatalogoWebUI.menuMovil.push({ nombre: "Actividad", nombrei: "Activity", tipo: "A" });
        if (GetObjConfiguracion().opMarca)
            CatalogoWebUI.menuMovil.push({ nombre: "Marca", nombrei: "Trademark", tipo: "M" });
        if (GetObjConfiguracion().opStand)
            CatalogoWebUI.menuMovil.push({ nombre: "Stand", nombrei: "Stand", tipo: "ST" });
        if (GetObjConfiguracion().opProducto)
            CatalogoWebUI.menuMovil.push({ nombre: "Producto", nombrei: "Product", tipo: "O" });
        if (GetObjConfiguracion().opRepresentada)
            CatalogoWebUI.menuMovil.push({ nombre: "Representadas", nombrei: "Represented", tipo: "R" });
        if (GetObjConfiguracion().opSector)
            CatalogoWebUI.menuMovil.push({ nombre: "Sector", nombrei: "Sector", tipo: "S" });

        //opciones dinámicas          
        if (data != null) {
            var arrayGenericas = data.d;
            for (j = 0; j < arrayGenericas.length; j++) {
                CatalogoWebUI.menuLateral.push({ nombre: arrayGenericas[j].no, nombrei: arrayGenericas[j].no, tipo: arrayGenericas[j].id });
                CatalogoWebUI.menuMovil.push({ nombre: arrayGenericas[j].no, nombrei: arrayGenericas[j].no, tipo: arrayGenericas[j].id });
            }
            $("#PanelBusquedas button").each(function () {
                if ($(this).height() > 20) {
                    $(this).css({ 'font-size': '12px' });
                }
            });
        }
        if (GetObjConfiguracion().busquedaActiva == "T")
            GetObjListaEmpresas().setBusquedaActiva("#btnTodasEmpresas");
        else
            GetObjListaEmpresas().setBusquedaActiva("#" + GetObjConfiguracion().busquedaActiva);
    }
}

ObjControlador.prototype = {
    
}

//esta clase es la que engancha componentes visuales con el modelo
function ViewModelListaEmpresas() {
    var self = this;
    //mostrar ocultar opciones generales
    self.verMapa = ko.observable(true);
    self.verPais = ko.observable(true);
    self.verSector = ko.observable(true);
    self.verActividad = ko.observable(true);
    self.verProducto = ko.observable(true);
    self.verRepresentada = ko.observable(true);
    self.verMarca = ko.observable(true);
    self.verStand = ko.observable(true);
    self.verCita = ko.observable(true);
    self.verEspecifico = ko.observable(true);
    self.verCabecera = ko.observable(true);
    self.verCabeceraIdioma = ko.observable(true);
    self.pagGrande = ko.observable(true);//paginaciones >=50
    self.verPaginacion = ko.observable(true);
    self.verSinDatos = ko.observable(false);

    self.InicializarUI = function ()
    {
        self.setversionPIM();
        self.setIdioma();
        self.verMapa(GetObjConfiguracion().opMapa);
        self.verPais(GetObjConfiguracion().opPais);
        self.verSector(GetObjConfiguracion().opSector);
        self.verActividad(GetObjConfiguracion().opActividad);
        self.verProducto(GetObjConfiguracion().opProducto);
        self.verRepresentada(GetObjConfiguracion().opRepresentada);
        self.verMarca(GetObjConfiguracion().opMarca);
        self.verStand(GetObjConfiguracion().opStand);
        self.verCita(GetObjConfiguracion().opCita);
        self.verEspecifico(GetObjConfiguracion().opEspecifico);
        self.setTextoFechaActualizada();
        self.setTextoFechaFinFeria();
        self.setTextoFavoritos();
        self.setTextoSinDatos();
    }

    self.setTextoSinDatos = function () {
        if (GetObjConfiguracion().fechaCarga.length <= 0) {
            self.verSinDatos(true);
            self.verPaginacion(false);
        }
    }

    self.setTextoFechaActualizada = function () {
        if (GetObjConfiguracion().fechaCarga.length > 0) {
            var diaCarga = getDiaFromFecha(GetObjConfiguracion().fechaCarga);
            var mesCarga = getMesFromCarga(GetObjConfiguracion().fechaCarga, GetObjConfiguracion().idio);
            var anioCarga = getAnioFromFecha(GetObjConfiguracion().fechaCarga);

            if (GetObjConfiguracion().idio == "es")
                self.fechaCarga("Datos actualizados a " + diaCarga + " de " + mesCarga + " de " + anioCarga);
            else
                self.fechaCarga("Last update on " + mesCarga + ", " + diaCarga + " " + anioCarga);
        }
    }

    self.setTextoFechaFinFeria = function () {
        if (GetObjConfiguracion().fechaFinFeria.length > 0) {
            var diaCarga = getDiaFromFecha(GetObjConfiguracion().fechaFinFeria);
            var mesCarga = getMesFromFecha(GetObjConfiguracion().fechaFinFeria);
            var anioCarga = getAnioFromFecha(GetObjConfiguracion().fechaFinFeria);
            var fechaFin = anioCarga + "-" + mesCarga + "-" + diaCarga;
            var d = new Date(fechaFin);
            d.setDate(d.getDate() + 31);
            var today = new Date();
            if (d < today) {
                if (GetObjConfiguracion().idio == "es")
                    self.fechaFinFeria("Información correspondiente a la edición pasada");
                else
                    self.fechaFinFeria("Information corresponding to the last edition");
            } else {
                $('#cartelEdicionPasada').hide();
            }
        }
        else {
            $('#cartelEdicionPasada').hide();
        }
    }

    self.setTextoFavoritos = function () {
        if (GetObjConfiguracion().idio == "es") {
            $("#txtFavoritosPabellon").text(self.language().mostrarFavorito);
            $("#txtFavoritosMapa").text(self.language().mostrarFavorito);
        }
        else {
            $("#txtFavoritosPabellon").text(self.language().mostrarFavorito);
            $("#txtFavoritosMapa").text(self.language().mostrarFavorito);
        }
    }
    self.setversionPIM = function () {
        if (GetObjConfiguracion().verPIM === 'S') {
            self.verCabecera(true);
            self.verCabeceraIdioma(false);
            self.setPrinterVisible(false);
            self.pagGrande(false);
        }
    }
    self.setIdioma = function () {
        if (GetObjConfiguracion().idio === 'es') {
            self.language(spanish);
            self.esEspanol(true);
            self.esIngles(false);
        }
        else {
            if (GetObjConfiguracion().idio === 'en')
            {
                self.language(english);
                self.esEspanol(false);
                self.esIngles(true);
            }
        }
    }
       
    //cambio de idioma de la aplicación
    self.language = ko.observable(spanish);
    self.chooseenglish = function () {
        self.language(english);
        self.esEspanol(false);
        self.esIngles(true);
        GetObjControlador().cambiarIdioma("en");
    };
    self.choosespanish = function () {
        self.language(spanish);
        self.esEspanol(true);
        self.esIngles(false);
        GetObjControlador().cambiarIdioma("es");
    };

    self.chooseenglishprint = function () {
        self.language(english);
    };
    self.choosespanishprint = function () {
        self.language(spanish);
    };

    self.listaempresas = ko.observableArray();
    self.limpiarListaEmpresas = function () {
        self.listaempresas.removeAll();
    };
    
    self.listaFavoritos = ko.observableArray();
    self.limpiarListaFavoritos = function () {
        self.listaFavoritos.removeAll();
    };

    self.listaBusquedaSimple = ko.observableArray();
    self.limpiarListaBusquedaSimple = function () {
        self.listaBusquedaSimple.removeAll();
    }

    self.listaBusquedaSimpleAsync = ko.computed(self.listaBusquedaSimple).extend({ throttle: 100 });

    self.menuLateral = ko.observableArray();
    self.limpiarMenuLateral = function () {
        self.menuLateral.removeAll();
    }

    self.menuMovil = ko.observableArray();
    self.limpiarMenuMovil = function () {
        self.menuMovil.removeAll();
    }

    self.getTituloGenerico = function (idenGEN) {
        var seat = ko.utils.arrayFirst(this.menuLateral(), function (item) {
            return item.tipo == idenGEN;
        });
        if (seat) {
            if (self.esEspanol() === true) 
                return seat.nombre;
            else 
                return seat.nombrei;
        }
        else
            return "";
    }

    self.sinDatos = ko.observable("");
    self.fechaCarga = ko.observable("");
    self.fechaFinFeria = ko.observable("");

    self.resultadosPagina = ko.observable("");
    self.numeroEmpresas = ko.observable("");

    self.tituloIndice = ko.observable("");

    self.esEspanol = ko.observable(true);
    self.esIngles = ko.observable(false);

    self.criterioElegido = ko.observable("");
    self.opcionElegida = ko.observable("");
    //self.setCriterioElegido = function (criterio) {
    //    self.opcionElegida("");
    //    self.criterioElegido(criterio.toUpperCase() + ": ");
    //}
    //self.setOpcionElegida = function (opcion) {
    //    self.opcionElegida("- " + opcion);

    //}

    self.flagOpcionElegida = ko.observable(false);
    self.setFlagOpcionElegida = function (valor) {
        self.flagOpcionElegida(valor);
    }
    
    self.setCriterioElegido = function (tipo) {
        var match = ko.utils.arrayFirst(self.menuLateral(), function (item) {
            return item.tipo === tipo;  
        });
        if (!match)
            self.criterioElegido("");
        else {
            if (self.esEspanol())
                self.criterioElegido(match.nombre);
            else
                self.criterioElegido(match.nombrei);
        }
    }
    
    self.idopcionElegida = ko.observable("");
    self.setIdOpcionElegida = function (id) {
        self.idopcionElegida(id);
    }

    self.setOpcionElegida = function () {
        GetObjListaEmpresas().cargarTxtOpcionElegida(GetObjConfiguracion().feria, GetObjConfiguracion().busquedaActiva,
                                                     GetObjConfiguracion().idio, self.idopcionElegida());
    }
    self.printVisible = ko.observable(true);
    self.setPrinterVisible = function (valor) {
        //si es pim nunca mostramos la impresora
        if (GetObjConfiguracion().verPIM == 'S')
            self.printVisible(false);
        else
            self.printVisible(valor);
        //self.printVisible(valor);
        //DDC comento todo esto porque no lo entiendo
        //if (!valor)  
        //    self.printVisible(valor);
        //else {
        //    if (getQueryVariable('MODO').toUpperCase() != 'PIM')
        //        self.printVisible(valor);
        //}
    }
    
    self.verTextFavoritos = ko.observable(true);

    self.goToSVR = function (objeto) {
        var newwindow = window.open(objeto.linkSVR, '', 'height=700,width=400,top=100,left=200');
        //var newwindow = window.open(objeto.linkSVR, '', 'height=470,width=430,top=200,left=300');
    }

    self.goToNovedades = function (objeto) {
        var newwindow = window.open(objeto.linkNovedades(), '', 'scrollbars=yes,width=700,height=400');
    }

};


function ViewModelFichaEmpresa() {

    var that = this;

    this.mostrarDatosPostales = ko.observable(true);
    this.mostrarPlano = ko.observable(true);
    this.verCita = ko.observable(true);
    this.verWeb = ko.observable(true);
    //cambio de idioma de la aplicación
    this.language = ko.observable(spanish);
    this.setIdioma = function () {
        if (GetObjConfiguracion().idio === 'es') {
            that.language(spanish);
            that.esEspanol(true);
            that.esIngles(false);
        }
        else {
            if (GetObjConfiguracion().idio === 'en') {
                that.language(english);
                that.esEspanol(false);
                that.esIngles(true);
            }
        }
        if (location.hash.search("#FICHA_EMPRESA") >= 0)
            GetObjFichaEmpresa().cargarFichaEmpresa(that.idEmpresa());
    }

    this.esEspanol = ko.observable(true);
    this.esIngles = ko.observable(false);


    this.idEmpresa = ko.observable();
    this.nombreEmpresa = ko.observable();
    this.logoEmpresa = ko.observable();
    this.representada = ko.observable(false);
    this.nombretipoEmpresa = ko.observable();
    this.direccion = ko.observable();
    this.cp = ko.observable();
    this.poblacion = ko.observable();
    this.provincia = ko.observable();
    this.pais = ko.observable();
    this.paisCatalogo = ko.observable();
    this.telefono = ko.observable();
    this.email = ko.observable();
    this.web = ko.observable();
    this.video = ko.observable();
    this.pabellon = ko.observable();
    this.stand = ko.observable();
    this.tipoE = ko.observable();
    this.linkSVR = ko.observable();
    this.linkNovedades = ko.observable();
    
    this.CPyPoblacion = ko.computed(function () {
        return this.cp() + " - " + this.poblacion();
    }, this);

    this.provinciayPais = ko.computed(function () {
        return this.provincia() + " (" + this.pais() + ")";
    }, this);
    
    this.bDesplegarDescr = ko.observable(true);
    this.bDesplegarSectores = ko.observable(true);
    this.bDesplegarFicheros = ko.observable(true);
    this.bDesplegarProductos = ko.observable(true);
    this.bDesplegarActividades = ko.observable(true);
    this.bDesplegarDestacados = ko.observable(true);
    this.bDesplegarGenericos = ko.observable(true);
    this.bDesplegarMarcas = ko.observable(true);
    this.bDesplegarRepresentadas = ko.observable(true);
    this.bDesplegarPaisesRepre = ko.observable(true);
    this.bDesplegarCoexpos = ko.observable(true);
    this.bDesplegarCampos = ko.observable(true);


    this.listaUbicaciones = ko.observableArray();
    this.listaRedes = ko.observableArray();
    this.descripcion = ko.observable();
    this.listaSectores = ko.observableArray();
    this.listaFicheros = ko.observableArray();
    this.listaProductos = ko.observableArray();
    this.listaActividades = ko.observableArray();
    this.listaDestacados = ko.observableArray();
    this.listaGenericos = ko.observableArray();
    this.listaMarcas = ko.observableArray();
    this.listaRepresentadas = ko.observableArray();
    this.listaPaisesRepre = ko.observableArray();
    this.listaCoexpos = ko.observableArray();
    this.listaCampos = ko.observableArray();
    
    this.versionNoImpr = ko.observable(true);
    this.setVersionPrint = function (valor) {
        this.versionNoImpr(valor);
    }
    
    this.desplegarDescr = function () {
        if (that.bDesplegarDescr())
            that.bDesplegarDescr(false);
        else
            that.bDesplegarDescr(true);
    }

    this.desplegarFicheros = function () {
        if (that.bDesplegarFicheros())
            that.bDesplegarFicheros(false);
        else
            that.bDesplegarFicheros(true);
    }

    this.desplegarSectores = function () {
        if (that.bDesplegarSectores())
            that.bDesplegarSectores(false);
        else
            that.bDesplegarSectores(true);
    }

    this.desplegarProductos = function () {
        if (that.bDesplegarProductos())
            that.bDesplegarProductos(false);
        else
            that.bDesplegarProductos(true);
    }

    this.desplegarDestacados = function () {
        if (that.bDesplegarDestacados())
            that.bDesplegarDestacados(false);
        else
            that.bDesplegarDestacados(true);
    }
    
    this.desplegarMarcas = function () {
        if (that.bDesplegarMarcas())
            that.bDesplegarMarcas(false);
        else
            that.bDesplegarMarcas(true);
    }
   
    this.desplegarActividades = function () {
        if (that.bDesplegarActividades())
            that.bDesplegarActividades(false);
        else
            that.bDesplegarActividades(true);
    }

    this.desplegarRepresentadas = function () {
        if (that.bDesplegarRepresentadas())
            that.bDesplegarRepresentadas(false);
        else
            that.bDesplegarRepresentadas(true);
    }

    this.desplegarPaisesRepre = function () {
        if (that.bDesplegarPaisesRepre())
            that.bDesplegarPaisesRepre(false);
        else
            that.bDesplegarPaisesRepre(true);
    }

    this.desplegarGene = function (generico) {
        if (generico.bDesplegarGene())
            generico.bDesplegarGene(false);
        else
            generico.bDesplegarGene(true);
    }
    
    this.desplegarCoexpos = function () {
        if (that.bDesplegarCoexpos())
            that.bDesplegarCoexpos(false);
        else
            that.bDesplegarCoexpos(true);
    }

    this.desplegarCampos = function () {
        if (that.bDesplegarCampos())
            that.bDesplegarCampos(false);
        else
            that.bDesplegarCampos(true);
    }

    this.goToSVR = function (objeto) {
        var newwindow = window.open(objeto.linkSVR(), '', 'height=700,width=400,top=100,left=200');
      //var newwindow = window.open(objeto.linkSVR(), '', 'height=470,width=430,top=200,left=300');
    }

    this.goToNovedades = function (objeto) {
        var newwindow = window.open(objeto.linkNovedades(), '', 'scrollbars=yes,width=700,height=400');
    }
    
    this.goToFicha = function (empresa) {
        //alert(empresa.id);
        var id = empresa.id;
        //GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'D');
        //GetObjFichaEmpresa().cargarFichaEmpresa(id);
        GetObjControlador().navegarAPagina(GetObjConstantes()._FICHA, "#FICHA_EMPRESA?emp=" + id);
    }

    this.goToMapa = function (ubicacion) {
        GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'M');
        GetObjConfiguracion().nombreEmpresa = that.nombreEmpresa();
        GetObjControlador().navegarAPagina(GetObjConstantes()._MAPA_FERIA, '#MAPA_FERIA?s=' + ubicacion.stand);//window.location.hash = '#MAPA_FERIA?s=' + ubicacion.stand;
    }
        
};
